import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../../../CommonUtils/httpBodyOptions';
import { Body } from '../tabs/Beneficiaries/components/EditAssetForm/components/AccountEditAssetForm/AccountEditAssetForm.meta';
import { useClientId } from '../../../../../_hooks/useClientId';
import { queryKeys } from '../../../../api/queryKeys';
import { useFpId } from '../../../../hooks/useFpId';

interface Params {
  body: Body;
  isSimulation: boolean;
}

const saveAccountBeneficiaries = (clientId: number) => ({ body, isSimulation }: Params) => {
  return authFetch(
    `/Consumer/AccountBeneficiariesUpdateV2/${
      isSimulation ? 'SaveSimulatedAccountBeneficiariesV2' : 'SaveAccountBeneficiariesV2'
    }`,
    {
      method: 'POST',
      ...httpBodyOptions({ ...body, clientId }, true),
    },
  );
};

export const useAccountsBeneficiariesMutation = () => {
  const queryClient = useQueryClient();

  const clientId = useClientId();

  const fpId = useFpId();

  return useMutation(saveAccountBeneficiaries(clientId), {
    async onSuccess() {
      const queryKey = queryKeys.estatePlanningExplanation(clientId, fpId);

      const optionsQueryKey = queryKeys.estatePlanningExplanationOptions(clientId, fpId);

      await queryClient.invalidateQueries(queryKey);
      await queryClient.invalidateQueries(optionsQueryKey);
    },
  });
};
